import { env } from "@/lib/env";

export type BookSessionContext = {
  email?: string;
  workflowId?: string;
  tciScore?: number;
  totalTrappedGbp?: string;
};

const DEFAULT_GOOGLE_APPOINTMENTS_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1a1ej2i9Z5CggNcGx1M9Xk_N-6-hM1OuX4lpJ0SbxdiWd0UcM6h1NJB4krms174iAtFot89Ve6?gv=true";

/**
 * Google Calendar Appointment Scheduling embed URL.
 * Prefills guest email when the schedule supports it.
 */
export function getBookingScheduleUrl(
  context: BookSessionContext = {},
): string {
  const base = (env.bookingUrl || DEFAULT_GOOGLE_APPOINTMENTS_URL).trim();
  if (!base) return "";

  const url = new URL(base);
  url.searchParams.set("gv", "true");

  if (context.email) {
    url.searchParams.set("email", context.email);
  }

  // Optional notes-style context when the appointment form exposes custom fields.
  if (context.workflowId) {
    url.searchParams.set("a1", `Workflow: ${context.workflowId}`);
  }
  if (
    typeof context.tciScore === "number" &&
    Number.isFinite(context.tciScore)
  ) {
    url.searchParams.set("a2", `TCI Score: ${Math.round(context.tciScore)}%`);
  }
  if (context.totalTrappedGbp) {
    url.searchParams.set("a3", `Trapped Margin: ${context.totalTrappedGbp}`);
  }

  return url.toString();
}
